<template>
	<b-card no-body>
		<b-form @submit="searchSubmit" @reset="clearSearchKey">
			<b-card-header>
				<b-row>
					<b-col cols="6">
						<h4 class="h3 mb-0">Search Criteria</h4>
					</b-col>

					<b-col cols="6" class="text-right">
						<b-button
							data-cy="mobility-search-search-btn"
							size="sm"
							type="submit"
							variant="primary"
							v-if="!submitLoading"
						>
							<i class="fa fa-search"></i>
							Search
						</b-button>
						<b-button class="btn btn-primary" variant="primary" size="sm" disabled v-if="submitLoading">
							<b-icon icon="circle-fill" animation="throb" font-scale="1"></b-icon>
							Searching...
						</b-button>
						<b-button size="sm" type="reset"><i class="fa fa-times mr-2"></i>Clear</b-button>
					</b-col>
				</b-row>
			</b-card-header>

			<b-card-body>
				<b-row>
					<b-col xl="7">
						<b-row>
							<b-col md="6">
								<b-row>
									<b-col md="4" xs="4" sm="4">
										<label for="start-imsi" class="font-weight-900 text-sm">Start IMSI</label>
									</b-col>
									<b-col md="8" xs="8" sm="8">
										<b-form-input
											data-cy="mobility-search-start-imsi-input"
											id="start-imsi"
											type="number"
											v-model="simsForm.fStartIMSI"
											size="sm"
											placeholder="Start IMSI"
										></b-form-input>
									</b-col>
								</b-row>
							</b-col>
							<b-col md="6">
								<b-row class="mt-sm-4 mt-md-0">
									<b-col md="4" xs="4" sm="4">
										<label for="iccid" class="font-weight-900 text-sm">ICCID</label>
									</b-col>
									<b-col md="8" xs="8" sm="8">
										<b-form-input
											id="iccid"
											size="sm"
											type="number"
											v-model="simsForm.fIccid"
											placeholder="ICCID"
										></b-form-input>
									</b-col>
								</b-row>
							</b-col>
						</b-row>

						<b-row class="mt-4">
							<b-col md="6">
								<b-row>
									<b-col md="4" xs="4" sm="4">
										<label for="end-imsi" class="font-weight-900 text-sm">End IMSI</label>
									</b-col>
									<b-col md="8" xs="8" sm="8">
										<b-form-input
											id="end-imsi"
											type="number"
											size="sm"
											v-model="simsForm.fEndIMSI"
											placeholder="End IMSI"
										></b-form-input>
									</b-col>
								</b-row>
							</b-col>
							<b-col md="6">
								<b-row class="mt-sm-4 mt-md-0">
									<b-col md="4" xs="4" sm="4">
										<label for="msisdn" class="font-weight-900 text-sm">MSISDN</label>
									</b-col>
									<b-col md="8" xs="8" sm="8">
										<b-form-input
											id="msisdn"
											type="number"
											size="sm"
											v-model="simsForm.fMsisdn"
											placeholder="MSISDN"
										></b-form-input>
									</b-col>
								</b-row>
							</b-col>
						</b-row>

						<b-row class="mt-4 mb-4">
							<b-col md="6">
								<b-row>
									<b-col md="4" xs="4" sm="4">
										<label for="sim-type" class="font-weight-900 text-sm">SIM Type</label>
									</b-col>
									<b-col md="8" xs="8" sm="8">
										<b-form-select
											id="sim-type"
											v-model="simsForm.fSimType"
											:options="simType"
											selected="All"
											value-field="simtype"
											text-field="simtype"
											size="sm"
											disabled-field="notEnabled"
										>
										</b-form-select>
									</b-col>
								</b-row>
							</b-col>
							<b-col md="6">
								<b-row class="mt-sm-4 mt-md-0">
									<b-col md="4" xs="4" sm="4">
										<label for="state" class="font-weight-900 text-sm">State</label>
									</b-col>
									<b-col md="8" xs="8" sm="8">
										<b-form-select
											id="state"
											v-model="simsForm.fState"
											:options="stateType"
											value-field="State"
											text-field="State"
											size="sm"
											disabled-field="notEnabled"
										></b-form-select>
									</b-col>
								</b-row>
							</b-col>
						</b-row>
					</b-col>
					<b-col xl="5"></b-col>
				</b-row>
			</b-card-body>
		</b-form>
	</b-card>
</template>
<script>
import searchDashboardService from "@/common/api-services/search-dashboard-service";

export default {
	name: "search-criteria",
	props: {},
	data() {
		return {
			simTypeSelect: "All",
			simType: [{simtype: "All"}, {simtype: "Combo"}, {simtype: "pSIM"}, {simtype: "eSIM"}],
			stateTypeSelect: "All",
			stateType: [],
			customerSelect: "Administrator",
			customerType: [],
			simsForm: {
				fStartIMSI: "",
				fEndIMSI: "",
				fSimType: "All",
				fIccid: "",
				fMsisdn: "",
				fState: "",
				fSort: "IMSI asc",
			},
			submitLoading: false,
		};
	},
	mounted() {
		this.$root.$on("getSimType", data => {
			this.simType = "All";
			this.simsForm.fSimType = this.simTypeSelect;
			if (data.length > 1) {
				this.simType = [];
				this.simType.push("All");
				data[1].forEach(type => {
					this.simType.push(type);
				});
			}
		});

		this.$root.$on("getStateType", type => {
			this.stateType = type;
			this.simsForm.fState = this.stateTypeSelect;
		});

		// //submit a search event.
		// let event = JSON.parse('{"isTrusted":true}');
		// this.searchSubmit(event);

		this.readCache();

		// this.doSearch();
	},
	methods: {
		doSearch() {
			this.writeCache();
			let {fStartIMSI, fEndIMSI, fSimType, fIccid, fMsisdn, fState, fSort} = this.simsForm;
			if (fSimType === "All") {
				fSimType = "";
			}
			if (fState === "All") {
				fState = "";
			}
			this.submitLoading = true;
			searchDashboardService
				.getSearchResultByFilter(fStartIMSI, fEndIMSI, fSimType, fIccid, fMsisdn, fState, 0, 25, fSort)
				.then(res => {
					this.submitLoading = false;
					if (res) {
						this.$root.$emit("getSearchResult", {res: res, filter: this.simsForm});
					} else {
						this.$root.$emit("getSearchResult", []);
					}
				});
		},

		searchSubmit(event) {
			this.$root.$emit("searchStarted", true);
			event.preventDefault();
			this.doSearch();
		},

		sortSearchEvent(sort) {
			this.simsForm.fSort = sort;
			this.searchSubmit();

			this.$root.$on("submitFilter", sortBy => {
				if (sortBy) {
					// you need to update the form name
					this.form.fSortBy = sortBy;
					//now call the search event to do the search
				}
			});
		},

		clearSearchKey(event) {
			event.preventDefault();
			this.simsForm.fStartIMSI = "";
			this.simsForm.fEndIMSI = "";
			this.simsForm.fMsisdn = "";
			this.simsForm.fIccid = "";
			this.simsForm.fSimType = "All";
			this.simsForm.fState = "All";
			this.simsForm.fSort = "IMSI asc";
			this.searchSubmit(event);
		},

		writeCache() {
			localStorage.setItem("simsForm", JSON.stringify(this.simsForm));
		},

		readCache() {
			let simsForm = JSON.parse(localStorage.getItem("simsForm"));
			if (simsForm) {
				this.simsForm = simsForm;
				this.stateTypeSelect = this.simsForm.fState;
			}
			this.doSearch();
		},
	},
};
</script>
